import { parseMcpToolKey } from './getToolIcon';
import type { ToolCallTranslationContext } from './translateAiTool';

/** Adds derived i18n interpolation keys for a specific tool key. */
export type ToolCallContextEnricher = (
  toolCall: ToolCallTranslationContext,
) => Record<string, unknown>;

const toolCallContextEnrichers = new Map<string, ToolCallContextEnricher>();

/** Registers an enricher for a tool key (`serverName__toolName`) or MCP server name. */
export function registerToolCallContextEnricher(
  toolKey: string,
  enricher: ToolCallContextEnricher,
): void {
  toolCallContextEnrichers.set(toolKey, enricher);
}

export function applyToolCallContextEnrichers(
  toolKey: string,
  toolCall: ToolCallTranslationContext,
): Record<string, unknown> {
  const mcpParts = parseMcpToolKey(toolKey);
  const serverEnricher = mcpParts ? toolCallContextEnrichers.get(mcpParts.serverName) : undefined;
  const toolEnricher = toolCallContextEnrichers.get(toolKey);
  return { ...(serverEnricher?.(toolCall) ?? {}), ...(toolEnricher?.(toolCall) ?? {}) };
}

export function clearToolCallContextEnrichers(): void {
  toolCallContextEnrichers.clear();
}
